var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.648,
    height: 32.575,
    viewBox: "0 0 28.648 32.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59273",
    "data-name": "Group 59273",
    transform: "translate(0 0.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221645",
    "data-name": "Path 221645",
    d: "M23.973,22.623a9.454,9.454,0,0,0,0-2.713l2.948-2.284a.694.694,0,0,0,.168-.886l-2.794-4.789a.705.705,0,0,0-.852-.3l-3.479,1.384A10.231,10.231,0,0,0,17.6,11.675l-.531-3.668a.679.679,0,0,0-.685-.581H10.8a.679.679,0,0,0-.685.581l-.531,3.668a10.76,10.76,0,0,0-2.361,1.356L3.743,11.648a.684.684,0,0,0-.852.3L.1,16.741a.678.678,0,0,0,.168.886L3.212,19.91a9.454,9.454,0,0,0,0,2.713L.265,24.906a.694.694,0,0,0-.168.886l2.794,4.789a.705.705,0,0,0,.852.3L7.222,29.5a10.231,10.231,0,0,0,2.361,1.356l.531,3.668a.679.679,0,0,0,.685.581h5.588a.679.679,0,0,0,.685-.581l.531-3.668A10.76,10.76,0,0,0,19.964,29.5l3.479,1.384a.684.684,0,0,0,.852-.3l2.794-4.789a.694.694,0,0,0-.168-.886ZM13.593,26.111a4.844,4.844,0,1,1,4.89-4.844A4.872,4.872,0,0,1,13.593,26.111Z",
    transform: "translate(0 -3.083)",
    fill: "#f66127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221646",
    "data-name": "Path 221646",
    d: "M34.089,15.058a7.529,7.529,0,1,1,5.324-2.205A7.529,7.529,0,0,1,34.089,15.058ZM34.089,1A6.525,6.525,0,1,0,38.7,2.915,6.525,6.525,0,0,0,34.089,1Z",
    transform: "translate(-12.971 -0.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221647",
    "data-name": "Path 221647",
    d: "M34.053.781a6.711,6.711,0,1,1-4.745,1.966A6.711,6.711,0,0,1,34.053.781Zm-.479,7.19h3.835a.479.479,0,1,0,0-.959H34.532V3.178a.479.479,0,1,0-.959,0Z",
    transform: "translate(-12.934 -0.515)",
    fill: "#fcba45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.f9b52f055828fed12e6e1f6cec71ced9.svg";
export { ForwardRef as ReactComponent };